import React, { Fragment, useEffect, useState } from "react";
// import CKEditors from "react-ckeditor-component";
import {
  Button,
  Form,
  Card,
  CardBody,
  Col,
  FormGroup,
  Input,
  Label,
  Row,
} from "reactstrap";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import {
  yupProductValidation,
  productSelectBoxValidtion,
  // productCodeValidation,
} from "../../utils/authValidation";
import { adminInstance } from "../../config/axios";
import { toast } from "react-toastify";
import { useHistory } from "react-router-dom";
import { useSelector } from "react-redux";
import Select from "react-select";
import prodImg from "../../assets/images/dashboard/product/20.jpg";
// import { queryString } from "../../utils/queryString";
// import { validateImage } from "../../utils/multiuseFunctions";
const ProductForm = ({
  payload,
  setPayload,
  // sizeArray,
  // productNatureArray,
  // colorArray,
  data,
}) => {
  ////
  const { _id } = payload || {};
  // const { id } = queryString();
  const result = useSelector((state) => state.admin);
  const {
    selectedCategory,
    // selectePartnerList,
    selectebrandList,
    selectedRarity,
    loginAdmin,
  } = result || {};
  const { role } = loginAdmin || [];

  //  console.log('selectedCategory==', selectedCategory, 'selectedRarity', selectedRarity,)
  let history = useHistory();
  const {
    register,
    //setValue,
    clearErrors,
    handleSubmit,
    formState: { errors },
    reset,
  } = useForm({
    mode: "onBlur",
    defaultValues: payload || {},
    resolver: yupResolver(yupProductValidation(_id)),
  });
  const [editData, setEditData] = useState();
  const [previewBannerImage, setPreviewBannerImage] = useState([]);
  const [editName, setEditName] = useState("");
  const [customErrors, setCustomErrors] = useState({});
  const [codeError, setCodeError] = useState({});
  const [isLoading, setIsLoading] = useState(false);
  const [ddd] = useState();
  const notValidateFields = [
    "brandId",
    "partnerId",
    "categoryId",
    "rarityLevel",
    "totalProduct",
  ];
  const onSubmitHandler = async (data) => {
    try {
      if (isLoading) return;
      const { custErrors, isValid } = productSelectBoxValidtion(
        payload,
        notValidateFields
      );
      setCustomErrors(custErrors);
      if (
        Object.keys(errors).length === 0 &&
        isValid &&
        !codeError?.productCode
      ) {
        if (_id) {
          setIsLoading(true);
          const response = await adminInstance().put(
            `/api/admin/updateProduct/${_id}`,
            { data, payload }
          );
          const { code, msg } = response.data;
          setEditData({ ...editData, isUpdate: true });
          if (code === 200) {
            toast.success(msg);
            reset();
            setIsLoading(false);
            history.push("/products/list_product");
          } else {
            toast.error(msg);
          }
        } else {
          setIsLoading(true);
          const response = await adminInstance().post(
            "/api/admin/createProduct",
            { data, payload }
          );
          const { code, msg } = response.data;
          if (code === 200) {
            toast.success(msg);
            reset();
            setIsLoading(false);
            history.push("/products/list_product");
          } else {
            toast.error(msg);
          }
        }
      }
    } catch (error) {
      console.log(error);
    }
  };

  const IncrementItem = (value, name) => {
    setPayload({ ...payload, [name]: parseInt(value, 10) + 1 });
  };

  const DecreaseItem = (value, name) => {
    if (value > 0) {
      setPayload({ ...payload, [name]: parseInt(value, 10) - 1 });
    }
  };
  const handleOnChange = (event, val) => {
    const { name, value } = event;
    if (name === "productCode") {
      setCodeError({});
    }

    if (name === "quickSell" || name === "visibility") {
      setPayload({ ...payload, [name]: val });
    } else if (name === "enableProduct" || name === "visibility") {
      setPayload({ ...payload, [name]: val });
    } else if (name === "checkTrack") {
      const quantVal = 0;
      setPayload({ ...payload, [name]: !val, trackQuantity: quantVal });
    } else {
      setPayload({ ...payload, [name]: value });
    }
  };

  const handlePhysicalItem = (selectedOption) => {
    if (selectedOption) {
      setPayload({ ...payload, physicalItem: selectedOption.value });
    } else {
      setPayload({ ...payload, physicalItem: "" });
    }
  };

  const handleSelectChange = (Opt, name) => {
    let newPayload = { ...payload };
    if (
      name === "categoryId" ||
      name === "capacity" ||
      name === "size" ||
      name === "color"
    ) {
      // console.log('conditionalRendering', Opt, name);
      const datas = Array.isArray(Opt) ? Opt.map((x) => x.value) : [];
      newPayload[name] = datas;
      // setPayload({ ...payload, [name]: datas });
      setPayload(newPayload);
    } else {
      newPayload[name] = Opt.value;
      setPayload(newPayload);
      // setPayload({ ...payload, [name]: Opt.value });
    }
    const { custErrors } = productSelectBoxValidtion(
      newPayload,
      notValidateFields
    );
    setCustomErrors(custErrors);
  };

  // const handleProductCode = async (event) => {
  //   const { value } = event;
  //   // console.log('name', name, value);
  //   if (value && !id) {
  //     const data = await productCodeValidation(value);
  //     // console.log('custErrors', data);
  //     setCodeError(data.custErrors);
  //   } else {
  //     setCodeError({});
  //   }
  // };

  const uploadBannerFile = async (data) => {
    try {
      //await validateImage(data.target.files[0]);
      const formdata = new FormData();
      formdata.append("file", data.target.files[0]);
      setPreviewBannerImage(data.target.files);
      clearErrors("logo");
      const response = await adminInstance().post(
        "api/admin/uploadProductImage",
        formdata
      );
      const { code, imageArr } = response.data;
      if (code === 200) {
        setPayload({ ...payload, bannerImage: imageArr[0] });
        // setCheckStatus(false);
      }
    } catch (error) {
      const { msg, valid } = error || {};
      if (!valid) {
        toast.error(msg);
      }
    }
  };

  useEffect(() => {
    const imageName = payload?.bannerImage;
    let name = "";
    if (imageName) {
      name = imageName?.substring(imageName?.lastIndexOf("/") + 1);
      name = name.replace(/_\d+/g, "");
      setEditName(name);
    }
  }, [payload]);

  return (
    <Fragment>
      <Form
        className="needs-validation user-add"
        onSubmit={handleSubmit(onSubmitHandler)}>
        <Row className="product-adding product-adding-page">
          <Col xl="6">
            <Card>
              <CardBody>
                <div className="digital-add needs-validation">
                  <FormGroup>
                    <Label className="col-form-label pt-0">
                      <span>*</span> Product Name
                    </Label>
                    <input
                      {...register("name")}
                      className="form-control"
                      type="text"
                      defaultValue={payload.name || ""}
                      onChange={(e) => handleOnChange(e.target)}
                      name="name"
                    />
                    <p className="text-danger">{errors.name?.message}</p>
                  </FormGroup>
                  <FormGroup>
                    <Label className="col-form-label pt-0">
                      <span>*</span> Sell Price
                    </Label>
                    <input
                      {...register("sellPrice")}
                      className="form-control"
                      type="number"
                      step="0.0001"
                      defaultValue={payload.sellPrice || ""}
                    />
                    <p className="text-danger">{errors.sellPrice?.message}</p>
                  </FormGroup>
                  <FormGroup>
                    <Label className="col-form-label pt-0">
                      <span>*</span> Purchase Price
                    </Label>
                    <input
                      {...register("purchasePrice")}
                      className="form-control"
                      type="number"
                      step="0.0001"
                      defaultValue={payload.purchasePrice || ""}
                    />
                    <p className="text-danger">
                      {errors.purchasePrice?.message}
                    </p>
                  </FormGroup>
                  <FormGroup>
                    <Label className="col-form-label pt-0">Product Code</Label>
                    <input
                      value={payload.productCode}
                      onChange={(e) => handleOnChange(e.target)}
                      className="form-control"
                      type="text"
                      name="productCode"
                    />
                    <p className="text-danger">{codeError?.productCode}</p>
                  </FormGroup>
                  <FormGroup>
                    <Label className="col-form-label">
                      <span></span> Total Product
                    </Label>
                    <fieldset className="qty-box ml-0">
                      <div className="input-group bootstrap-touchspin">
                        <div className="input-group-prepend">
                          <Button
                            className="btn btn-primary btn-square bootstrap-touchspin-down"
                            type="button"
                            onClick={() =>
                              DecreaseItem(payload.totalProduct, "totalProduct")
                            }>
                            <i className="fa fa-minus"></i>
                          </Button>
                        </div>
                        <div className="input-group-prepend">
                          <span className="input-group-text bootstrap-touchspin-prefix"></span>
                        </div>
                        <Input
                          className="touchspin form-control"
                          type="number"
                          value={payload.totalProduct || ""}
                          onChange={(e) => handleOnChange(e.target)}
                          name="totalProduct"
                        />
                        <div className="input-group-append">
                          <span className="input-group-text bootstrap-touchspin-postfix"></span>
                        </div>
                        <div className="input-group-append ml-0">
                          <Button
                            className="btn btn-primary btn-square bootstrap-touchspin-up"
                            type="button"
                            onClick={() =>
                              IncrementItem(
                                payload.totalProduct,
                                "totalProduct"
                              )
                            }>
                            <i className="fa fa-plus"></i>
                          </Button>
                        </div>
                      </div>
                    </fieldset>
                    <p className="text-danger">{customErrors?.totalProduct}</p>
                  </FormGroup>
                  <FormGroup>
                    <Label className="col-form-label">
                      <span>*</span>
                      Category
                    </Label>
                    <Select
                      isMulti
                      defaultValue={payload.setCategory || []}
                      onChange={(opt) => handleSelectChange(opt, "categoryId")}
                      options={selectedCategory}
                      isClearable
                      name="categoryId"
                    />

                    <p className="text-danger">{customErrors?.categoryId}</p>
                  </FormGroup>
                  <FormGroup>
                    <Label className="col-form-label">
                      <span>*</span> Brand
                    </Label>
                    <Select
                      isMulti={false}
                      defaultValue={payload.setBrand || []}
                      onChange={(opt) => handleSelectChange(opt, "brandId")}
                      value={selectebrandList.find(
                        (option) => option.value === payload.brandId
                      )}
                      options={selectebrandList}
                      isClearable
                      name="brandId"
                    />
                    <p className="text-danger">{customErrors?.brandId}</p>
                  </FormGroup>
                  <FormGroup>
                    <Label className="col-form-label">
                      <span>*</span> Rarity Level
                    </Label>

                    <Select
                      isMulti={false}
                      onChange={(opt) => handleSelectChange(opt, "rarityLevel")}
                      defaultValue={payload.setRarity || []}
                      options={selectedRarity}
                      isClearable
                      name="rarityLevel"
                      required
                    />
                    <p className="text-danger">{customErrors?.rarityLevel}</p>
                  </FormGroup>
                </div>
              </CardBody>
            </Card>
          </Col>
          <Col xl="6">
            <Card>
              <CardBody>
                <div className="digital-add needs-validation">
                  <FormGroup>
                    <Label className="col-form-label">
                      <span>*</span> Physical Item
                    </Label>
                    <Select
                      isMulti={false}
                      onChange={handlePhysicalItem}
                      value={{
                        label: payload.physicalItem === true ? "Yes" : "No",
                        value: payload.physicalItem,
                      }}
                      options={[
                        { label: "Yes", value: true },
                        { label: "No", value: false },
                      ]}
                      isClearable
                      name="physicalItem"
                    />
                    <p className="text-danger">{customErrors?.brandId}</p>
                  </FormGroup>
                  <FormGroup className=" mb-0">
                    <div className="description-sm">
                      <Label className="col-form-label">Add Description</Label>
                      <textarea
                        rows="6"
                        cols="12"
                        {...register("description")}
                        className="form-control"
                        type="text"
                        defaultValue={payload.description || ""}
                      />
                    </div>
                  </FormGroup>
                  <p>{ddd}</p>

                  <FormGroup>
                    <Label className="col-form-label pt-0">
                      {" "}
                      <span>*</span>Product Image
                    </Label>
                    <div className="dropzone">
                      <div className="upload-img-preview">
                        {payload.bannerImage ? (
                          <div className="img-preview">
                            <img
                              src={
                                payload.bannerImage ||
                                URL.createObjectURL(previewBannerImage)
                              }
                              alt="NoImageFound"
                            />{" "}
                          </div>
                        ) : (
                          <img
                            className="img-preview"
                            src={prodImg}
                            alt="NoImageFound"
                          />
                        )}
                      </div>
                      <div className="file-upload">
                        <div className="file-select">
                          <div className="file-select-button" id="fileName">
                            Choose File
                          </div>
                          <div className="file-select-name" id="noFile">
                            {editName || "No file chosen..."}
                          </div>
                          <input
                            {...register("logo")}
                            id="chooseFile"
                            type="file"
                            accept="image/png, image/gif, image/jpeg"
                            onChange={uploadBannerFile}
                          />
                        </div>
                        <p className="text-danger err-message pt-2">
                          {errors.logo?.message}
                        </p>
                      </div>
                    </div>
                  </FormGroup>
                  {role?.some((r) =>
                    ["suUsers", "superAdmin", "writeProduct"].includes(r)
                  ) && (
                    <FormGroup>
                      <div className="product-buttons text-center mt-4">
                        <Button
                          disabled={isLoading}
                          type="submit"
                          color="primary">
                          SUBMIT
                        </Button>
                      </div>
                    </FormGroup>
                  )}
                </div>
              </CardBody>
            </Card>
          </Col>
        </Row>
      </Form>
    </Fragment>
  );
};

export default ProductForm;
